<template>
  <JobOfferLanding />
</template>

<script>
import JobOfferLanding from './components/pages/JobOfferLanding';

import utils from './lib/utils';

export default {
  name: 'JobSuggestionApp',
  components: {
    JobOfferLanding
  },
  beforeCreate() {
    if (!utils.hasProperty(window.translations, 'dict')) {
      this.$store
        .dispatch('translations/fetchAll', window.translations)
        .then((dict) => {
          console.log('dict fetched');
          console.log(dict);
          this.$store.state.translations.dict = dict;
        });
    } else {
      this.$store.commit('translations/setDict', window.translations.dict);
    }
    // Load appointment?
  }
};
</script>

<style lang="scss">
@import 'scss/app';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 1200px;
  width: 100%;
  min-height: 100vh;
}

/* overwriting existing css */
.dashboard-applicant-extended {
  margin: 0 !important;
}

</style>
